import * as actionTypes from './actionTypes';

const initialState = {
  ids: [],
  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_ALL_SUCCESS:
      return {
        ...state,
        ids: action.ids,
        isLoading: false,
      };
    default:
      return state;
  }
};
